import { Node as ariaNode } from "../../index.js";
/**
 * Check if a node is included in the accessibility tree.
 *
 * @remarks
 * It's possible for a node itself to be ignored in the accessibility tree while
 * still having children that aren't.
 *
 * @public
 */
export function isIncludedInTheAccessibilityTree(device) {
    return (node) => !ariaNode.from(node, device).isIgnored();
}
/**
 * Check if a node is ignored in the accessibility tree.
 *
 * @remarks
 * It's possible for a node itself to be ignored in the accessibility tree while
 * still having children that aren't.
 *
 * @public
 */
export function isIgnored(device) {
    return (node) => ariaNode.from(node, device).isIgnored();
}
//# sourceMappingURL=is-included-accessibility-tree.js.map